<template>
    <div class="app flex-row align-items-center">
      <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card-group">
            <div class="card p-4">
              <div class="card-body">
                <template v-if="!recuperar">
                  <h1>Ingresar</h1>
                  <p class="text-muted">Bienvenido a la Era Digital</p>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="fa fa-building"/>
                      </span>
                    </div>
                    <input class="form-control" v-model="form.ruc" type="text" placeholder="RUC">
                  </div>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="fa fa-user"/>
                      </span>
                    </div>
                    <input class="form-control" v-model="form.usuario" type="text" placeholder="USUARIO">
                  </div>
                  <div class="input-group mb-4">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="fa fa-key"/>
                      </span>
                    </div>
                    <input class="form-control" v-model="form.clave" type="password" placeholder="CLAVE" @keyup.enter="dologin">
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <template v-if="!loading">
                        <button class="btn btn-primary btn-pill px-4" type="button" @click="dologin"><i class="fa fa-sign-in"/>INGRESAR</button>
                      </template>
                      <template v-else>
                        <button class="btn btn-secondary btn-pill px-4 disabled" type="button" :disabled="loading"><i class="fa fa-spin fa-spinner" />CARGANDO</button>
                      </template>
                    </div>
                    <div class="col-6 text-right">
                      <b-button v-model="recuperar" @click="changeView(1)" variant="link">Olvidé mi clave</b-button>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <h3>Recuperar Contraseña</h3>
                  <hr>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="fa fa-id-card" />
                      </span>
                    </div>
                    <input class="form-control" v-model="ruc" type="text" placeholder="RUC">
                  </div>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="fa fa-user"/>
                      </span>
                    </div>
                    <input class="form-control" v-model="usuario" type="text" placeholder="Usuario">
                  </div>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="fa fa-envelope"/>
                      </span>
                    </div>
                    <input class="form-control" v-model="email" type="email" placeholder="Correo">
                  </div>
                  <div class="col-12 text-center">
                    <template v-if="sendRecovery">
                      <button class="btn btn-warning btn-pill px-4" v-if="validateRecovery()" type="button" @click="recuperarClave()"><i class="fa fa-sign-in"/>ENVIAR</button>
                      <button class="btn btn-warning btn-pill px-4" v-else type="button" disabled><i class="fa fa-sign-in"/>ENVIAR</button>
                    </template>
                    <template v-else>
                      <button class="btn btn-secondary btn-pill px-4 disabled" type="button" disabled><i class="fa fa-spin fa-spinner"/>ENVIANDO</button>
                    </template>
                    <button class="btn btn-danger btn-pill px-4" type="button" @click="changeView(0)"><i class="fa fa-arrow-left"/> ATRAS</button>
                  </div>
                </template>
              </div>
            </div>
            <div class="card text-white bg-light py-5 d-md-down-none" style="width:44%">
              <div class="card-body text-center">
                <div class="mt-5">
                  <img src="images/logofo2.png" alt="Logo">
                </div>
              </div>
            </div>
          </div>
          <br>
          <div class="card-group">
            <div class="card p-0"> 
              <div class="mt-3 ml-4"><b>ACCESOS DIRECTO:</b></div>
              <div class="card-body">        
                <b-row>
                  <b-col cols="2">
                    <div>
                      <div class="fondo">
                        <a href="https://wenet.pe/" target="_blank"><img src="images/Wenet.png" class="imagen"></a>
                        <div class="nombreImagen">
                          Wenet
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="2">
                    <div>
                      <div class="fondo">
                        <a href="https://menu.facturaonline.pe/#/login" target="_blank"><img src="images/Menu.png" class="imagen"></a>
                        <div class="nombreImagen">
                          Menu
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="2">
                    <div>
                      <div class="fondo">
                        <a href="https://intranet.facturaonline.pe/login" target="_blank"><img src="images/Intranet.png" class="imagen"></a>
                        <div class="nombreImagen">
                          Intranet
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="2">
                    <div>
                      <div class="fondo">
                       <a href="https://tienda.facturaonline.pe/login" target="_blank"><img src="images/Tienda.png" class="imagen"></a>
                       <div class="nombreImagen">
                          Tienda
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="2">
                    <div>
                      <div class="fondo">
                       <a href="https://parking.facturaonline.pe/" target="_blank"><img src="images/Parking.png" class="imagen"></a>
                       <div class="nombreImagen">
                          Parking
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="2">
                    <div>
                      <div class="fondo">
                        <a href="https://libroreclamaciones.facturaonline.pe/" target="_blank"><img src="images/LibroReclamaciones.png" class="imagen"></a>
                        <div class="nombreImagen">
                          Lib. Reclam.
                        </div>
                      </div>
                    </div>
                  </b-col>                
                </b-row>
              </div>
            </div>
          </div>
          <br>
          <template>
            <b-btn 
              class="wrapper button_slide slide_right" 
              @click="redirectToPage" 
              >
              Crea tu empresa RUC 20 Aquí 
              <img src="images/empresa2.jpeg" class="imagenBoton">
              S/499
            </b-btn>
          </template>
        </div>
      </div>
    </div>
      <vue-snotify/>
    </div> 
</template>

<script>
// import { mapState, mapActions } from 'vuex'
import axios from 'axios'

export default {
  name: 'login',
  data () {
    return {
      form:{
        ruc: '',
        usuario: '',
        clave: ''
      },
      submitted: false,
      loading: false,
      recuperar: false,
      usuario: '',
      ruc: '',
      email: '',
      sendRecovery: true,
      total:0.0,
      totalItems:[],
    }
  },
  computed: {
  },
  created () {
  },
  watch: {
  },
  methods: {
    redirectToPage() {
      window.open('http://telemovildata.com/tuempresa/', '_blank');
    },
    changeView: function (val) {
      if(val === 1){
        this.recuperar = true;
        this.ruc = '';
        this.usuario = '';
        this.email = ''
      }else if(val === 0){
        this.recuperar = false;
        this.ruc = '';
        this.usuario = '';
        this.email = ''
      }
    },
    validateRecovery: function () {
      if(this.usuario !== '' && this.ruc !== '' && this.email !== ''){
        return true
      }else{
        return false
      }
    },
    recuperarClave: function () {
      this.sendRecovery = false;
      axios
        .post(process.env.VUE_APP_API_URL + 'usuario/recuperar',{
          token: this.$store.getters.userToken,
          ruc: this.ruc,
          user: this.usuario,
          email: this.email
        })
        .then(response => (
          this.responseRecuperarClave(response.data.msg)
        ))
        .catch(error => {
          this.$snotify.error(error.response.data.msg, 'Error');
          this.sendRecovery = true;
        })
      },
      responseRecuperarClave: function (val) {
        if(val === 'La contraseña fue enviada a su correo electrónico'){
          this.$snotify.success(val, 'Éxito');
          this.sendRecovery = true;
          this.recuperar = false;
          this.ruc = '';
          this.usuario = '';
          this.email = ''
        }else{
          this.$snotify.error(val, 'Error');
          this.sendRecovery = true;
          this.recuperar = true
        }
      },
      dologin: function() {
        this.submitted = true;
        this.loading = true;
        axios
        .post(process.env.VUE_APP_API_URL + 'login',
          this.form
        )
        .then(response => {
          this.$store.commit('loginuser', response.data);
          this.igvFO(),
          this.$snotify.success(response.data.response.msg, 'Éxito');
          this.$router.push('/emision/factura');//.catch(err => {})
          this.recibeTotalItems()
        })
        .catch(error => {
          this.submitted = false;
          this.loading = false;
          this.$snotify.error(error.response.data.msg, 'Error');
          })
      },
      igvFO(){
        axios
        .post(process.env.VUE_APP_API_URL + 'usuario/series/'+1,{
          token: this.$store.getters.userToken,
        })
        .then(response=>(
          this.$store.commit('setigv', response.data.igv)
        ))
      },
      recibeTotalItems(){
        axios
        .post(process.env.VUE_APP_API_URL + "productos/listar",{
          token: this.$store.getters.userToken,
        })
        .then(
          response => (
            (this.total = response.data.producto.total),
            this.cargandoItems(this.total)
          ))
          .catch(function(error) {
          this.$snotify.error(error.response.data.response.message, "Error")
          });
      },
      cargandoItems(valorTotal){
        axios
        .post(process.env.VUE_APP_API_URL + "productos/listar",{
          token: this.$store.getters.userToken,
          limit: valorTotal
        })
        .then(
          response => (
            (this.totalItems = response.data.producto.data),
            this.concatenarTodo(this.totalItems)
          ))
          .catch(function(error) {
          this.$snotify.error(error.response.data.response.message, "Error")
          });
      },
      concatenarTodo(a){
        let newArrayConcat = [].concat.apply([], a);
        this.$store.commit('listadoTotalItems',a);
      },
  }
};
</script>
<style scoped>
.app{
    background-image: url('/images/bglogin.jpeg');
    background-repeat: no-repeat;
    background-size: cover;   
}
.menus{
	border: none !important;
}
.imagen{
  width: 80%;
  height:70%;
  margin-left: 12%;
  margin-top: 5px;
}
.fondo{
  /* background-color:skyblue; */
  width:100%;
  height:90px;
  border-radius:9px
}
.fondo:hover{
  background-color: #e8f0fe;
}
.nombreImagen{
  text-align:center;
  margin-bottom: 20px;
}
.wrapper{
  padding: 10px 20px;
  font-size: 20px;
  border-radius: 5px;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
  display: block;
  width: 100%;

}
.button_slide {
  background-color: #7e0501;
  color: white;
  font-size: 30px;
  border: 2px solid rgb(140, 10, 10);
  border-radius: 10px;
  display: inline-block;
  letter-spacing: 1px;
  cursor: pointer;
  box-shadow: inset 0 0 0 0 #7e0501;
  -webkit-transition: ease-out 0.4s;
  -moz-transition: ease-out 0.4s;
  transition: ease-out 0.4s;
}
.slide_right:hover {
  box-shadow: inset 730px 0 0 0 #c9130d;
}
.imagenBoton{
  border-radius: 10px;
  width: 10%;
  height: 10%;
  margin-left: 10px;
  margin-top: 5px;
}
</style>